@if (market) {
  <div class="container-fluid edit-alerts">
    <div class="row d-flex align-items-center mt-md-2 mt-4">
      <div class="col-1">
        <span class="text-left" routerLink="/manageAlerts" id="edit-alerts-link">
          <i class="icon-edponline-Bra-073 rotate-90 font-size-24 color-black"></i>
        </span>
      </div>
    </div>
    <div class="row d-flex justify-content-center mt-4 detail-product-name">
      {{ market.nm | marketName }}<span>{{ market.nm | marketInfo }}</span>
    </div>
    <div class="row line"></div>
    <div class="row my-4">
      <div class="d-flex justify-content-between col-12 col-md-8 offset-md-2 px-4">
        <div>
          <span class="last-quotation">{{'edp.emarket.editar.alertas' | translate}}</span>
        </div>
        <div>
          <span class="edit-product-price color">{{ market.vl }} </span>
          <span class="heading-5-616161-copy-7">{{ market.vu }}</span>
        </div>
      </div>
    </div>
    <form [formGroup]="editAlertForm" (ngSubmit)="onSubmit()" class="px-2">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2">
          <div class="form-group">
            <app-variation-select></app-variation-select>
          </div>
          <div class="form-group">
            <app-price-input [form]="editAlertForm"></app-price-input>
          </div>
        </div>
      </div>
      <div class="row px-3">
        <div class="col-12 offset-md-2 col-md-8 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-0">
          <button class="btn bg w-100" type="submit" id="btn-confirm" [disabled]="editAlertForm.invalid || pending">
            @if (pending) {
              <span class="spinner-border" style="width: 1.25rem; height: 1.25rem;" role="status" aria-hidden="true"></span>
            } @else {
              <span class="bg-text">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
            }
          </button>
        </div>
      </div>
    </form>
    <div class="row mt-3 px-4">
      <div class="col-12 offset-md-2 col-md-8 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-0">
        <button class="btn bg-2 w-100" routerLink="/manageAlerts" id="btn-cancel">
          <span class="bg-text">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
}
